module.exports = __webpack_public_path__ + "static/img/photo-about_xs.01d1d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x-small/photo-about_xs.jpg
// module id = arl9
// module chunks = 1